import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Single Canvas icon. Exported from Figma (Bombiix 2026). */
const SingleCanvasIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M15.8994 7.59961C15.8994 5.66661 14.3324 4.09961 12.3994 4.09961H7.59961C5.66662 4.09961 4.09961 5.66661 4.09961 7.59961V12.3994C4.09961 14.3324 5.66661 15.8994 7.59961 15.8994H12.3994C14.3324 15.8994 15.8994 14.3324 15.8994 12.3994V7.59961ZM16.8994 12.3994C16.8994 14.8847 14.8847 16.8994 12.3994 16.8994H7.59961C5.11433 16.8994 3.09961 14.8847 3.09961 12.3994V7.59961C3.09961 5.11433 5.11433 3.09961 7.59961 3.09961H12.3994C14.8847 3.09961 16.8994 5.11433 16.8994 7.59961V12.3994Z"
      fill="currentColor"
    />
  </svg>
);

export default SingleCanvasIcon;
